import { ComponentNameEnum, BaseFieldConfig } from '@/types';

const menuInputGroupConfig: BaseFieldConfig = {
  componentName: ComponentNameEnum.MENU_INPUT_GROUP,
  options: {
    defaultValue: [],
    draggable: true,
  },
};

export default menuInputGroupConfig;
